import React, { useState, useEffect, useContext } from "react";

//Context
import { AuthContext } from '../../../../common/middlewares/Auth';

//Librerias
import { Controller } from "react-hook-form";
import { NumberFormatBase } from "react-number-format";
import "animate.css";

//Componentes de Material UI
import {
    Box,
    Paper,
    Grid,
    CircularProgress,
    Tooltip,
    Alert,
    AlertTitle,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Dialog,
    Button,
    useTheme,
    useMediaQuery,
    TextField,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    FormHelperText,
    FormLabel,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";

//Componentes
import DropdownEmpresasExternas from "./dropdownEmpresasExternas";
import DropdownSectorEmpresarial from "./dropdownSectorEmpresarial";
import DropdownBeneficios from "./dropdownBeneficios";
import DropdownCargosExternos from "./dropdownCargosExternos";
import SelectFuenteOferta from "./selectFuenteOferta";
import SelectPorqueSiVolveria from "./selectPorqueSiVolveria";
import SelectPorqueNoVolveria from "./selectPorqueNoVolveria";
import SelectMotivoRetiro from "./selectMotivoRetiro";
import SelectAspectoDestacar from "./selectAspectoDestacar";
import SelectAspectoMejorar from "./selectAspectoMejorar";
import SelectMejorChoucair from "./selectMejorChoucair";
import SelectRelacionEquipo from "./selectRelacionEquipo";
import SelectComunicacionSalida from "./selectComunicacionSalida";

const PaperNoVoluntaria = ({
    values,
    isTable,
    index,
    control,
    disabled,
    errors,
    getValues,
    required,
    remove,
    size,
    setValue,
    clearErrors,
    isPreview,
    sede
}) => {
    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================
    const { strInfoUser } = useContext(AuthContext);

    //===============================================================================================================================================
    //========================================== Declaracion de estados =============================================================================
    //===============================================================================================================================================
    const [data, setData] = useState({
        id: null,
        intId: null,
        strTipoRetiro: "",
        strMotivoRetiroUno: "",
        strMotivoRetiroDos: "",
        strObservacionRetiroUno: "",
        strObservacionRetiroDos: "",
        strAspectosMejorarJefeUno: "",
        strAspectosMejorarJefeDos: "",
        strObservacionMejorarJefe: "",
        strAspectosDestacarJefe: "",
        strObservacionDestacarJefe: "",
        strMejorChoucair: "",
        strObservacionMejorChoucair: "",
        strModeloLiderazgo: "",
        strIncentivoBuscarTrabajo: "",
        strNombreEmpresaTrabajar: "",
        strSectorEmpresaTrabajar: "",
        strBeneficiosOfrecidos: "",
        strCargoADesempeñar: "",
        strDondeLlegoOferta: "",
        strSalarioOfrecido: "",
        strPrograma: "",
        strUniversidad: "",
        strObservacionRegreso: "",
        strComentarioAdicional: "",
        btVolveriaCHC: null,
        btRealizoEncuesta: "",
        dtFechaRetiro: null,
    });

    const [loading, setLoading] = useState(true);
    const [openCollapese, setOpenCollapse] = useState(true);
    const [openModalDelete, setOpenModalDelete] = useState(false);

    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const theme = useTheme();
    const bitMobile = useMediaQuery(theme.breakpoints.down("sm"));

    //===============================================================================================================================================
    //========================================== Funciones ==========================================================================================
    //===============================================================================================================================================
    const handlerChangeOpenCollapse = () => {
        setOpenCollapse(!openCollapese);
    };

    const handlerChangeOpenModalDelete = () => {
        setOpenModalDelete(!openModalDelete);
    };

    //===============================================================================================================================================
    //========================================== useEffects =========================================================================================
    //===============================================================================================================================================
    useEffect(() => {
        setLoading(true);

        if (values) {
            setData({
                intId: values?.intId ?? null,
                intIdColaborador: values?.intIdColaborador ?? null,
                intIdColaboradorAdmin: values?.intIdColaboradorAdmin ?? null,
                strTipoRetiro: values?.strTipoRetiro ?? null,
                strMotivoRetiroUno: values?.strMotivoRetiroUno ?? null,
                strMotivoRetiroDos: values?.strMotivoRetiroDos ?? null,
                strObservacionRetiroUno: values?.strObservacionRetiroUno ?? null,
                strAspectosMejorarJefeUno: values?.strAspectosMejorarJefeUno ?? null,
                strObservacionMejorarJefe: values?.strObservacionMejorarJefe ?? null,
                strAspectosDestacarJefe: values?.strAspectosDestacarJefe ?? null,
                strRelacionEquipoTrabajo: values?.strRelacionEquipoTrabajo ?? null,
                btFuncionesClaras: values?.btFuncionesClaras ?? null,
                strFuncionesClarasPorque: values?.strFuncionesClarasPorque ?? null,
                btEspaciosFormales: values?.btEspaciosFormales ?? null,
                strAyudadoDesempeñarte: values?.strAyudadoDesempeñarte ?? null,
                btRecibisteApoyo: values?.btRecibisteApoyo ?? null,
                btIdentificadoCultura: values?.btIdentificadoCultura ?? null,
                strIdentificadoCuturaPorque: values?.strIdentificadoCuturaPorque ?? null,
                strMejorChoucair: values?.strMejorChoucair ?? null,
                strAspectoMejorarCH: values?.strAspectoMejorarCH ?? null,
                strObservacionMejorChoucair: values?.strObservacionMejorChoucair ?? "",
                strNombreEmpresaTrabajar: values?.strNombreEmpresaTrabajar ?? null,
                strSectorEmpresaTrabajar: values?.strSectorEmpresaTrabajar ?? null,
                strBeneficiosOfrecidos: values?.strBeneficiosOfrecidos ?? null,
                strCargoADesempeñar: values?.strCargoADesempeñar ?? null,
                strDondeLlegoOferta: values?.strDondeLlegoOferta ?? null,
                SalarioOfrecido: values?.SalarioOfrecido ?? null,
                strRangoSalarial: values?.strRangoSalarial ?? null,
                strProcesoComunicacionSalida: values?.strProcesoComunicacionSalida ?? null,
                strObservacionRegreso: values?.strObservacionRegreso ?? "",
                strComentarioAdicional: values?.strComentarioAdicional ?? "",
                btVolveriaCHC: values?.btVolveriaCHC ?? null,
                dtmActualizacion: values?.dtmActualizacion ?? null,
                btRealizoEncuesta: values?.btRealizoEncuesta ?? false,
                btEncuestaActiva: values?.btEncuestaActiva ?? true,
                strTipoEncuesta: values?.strTipoEncuesta ?? null,
                dtFechaRetiro: values?.dtFechaRetiro ?? null,
            });
        }

        setLoading(false);

        // eslint-disable-next-line
    }, [values]);

    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    if (loading || !data.intId) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
            >
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (!data.intId) {
        return (
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    alignItems: {
                        xs: "flex-end",
                        md: "center",
                    },
                    marginBottom: "15px",
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Alert severity="error" style={{ marginBottom: "15px" }}>
                        <AlertTitle>
                            <b>Se esperaba un identificador</b>
                        </AlertTitle>
                        Ha ocurrido un error al renderizar el formulario de
                        titulaciones
                    </Alert>
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: {
                    xs: "column",
                    md: "row",
                },
                alignItems: {
                    xs: "flex-end",
                    md: "center",
                },
                marginBottom: "15px",
            }}
        >

            <Box sx={{ flexGrow: 1 }}>
                <Paper
                    style={{
                        backgroundColor: "#ffffff",
                        padding: "15px",
                    }}
                >
                    <Grid container direction="row" spacing={2}>
                        {isTable && (
                            <Grid item xs={12}>
                                <Controller
                                    name={`objEncuestaRetiro.dtFechaRetiro`}
                                    defaultValue={data.dtFechaRetiro}
                                    render={({ field: { name, value, onChange } }) => (
                                        <MobileDatePicker
                                            label="Fecha de retiro"
                                            value={value}
                                            name={name}
                                            format="dd/MM/yyyy"
                                            onChange={(e) => {
                                                onChange(e);
                                            }}
                                            slotProps={{
                                                textField: {
                                                    name: name,
                                                    fullWidth: true,
                                                    required: true,
                                                },
                                            }}
                                        />
                                    )}
                                    control={control}
                                />
                            </Grid>
                        )}
                        {/* Lo mejor de Choucair */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name={`objEncuestaRetiro.strMejorChoucair`}
                                defaultValue={data.strMejorChoucair}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectMejorChoucair
                                        label="¿Qué aspectos positivos destacas de Choucair?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strMejorChoucair
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strMejorChoucair?.message ||
                                            "Selecciona el aspecto positivo de Choucair"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona el aspecto positivo de Choucair"
                                }}
                            />
                        </Grid>
                        {/* Nombre de la empresa */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="objEncuestaRetiro.strAspectoMejorarCH"
                                defaultValue={data.strAspectoMejorarCH}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <SelectMejorChoucair
                                        label="¿Qué aspectos a mejorar tiene Choucair?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strAspectoMejorarCH
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strAspectoMejorarCH?.message ||
                                            "Selecciona el aspecto a mejorar de Choucair"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona el aspecto a mejorar de Choucair",
                                }}
                            />
                        </Grid>
                        {/* Aspecto a mejorar */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name={`objEncuestaRetiro.strAspectosMejorarJefeUno`}
                                defaultValue={data.strAspectosMejorarJefeUno}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectAspectoMejorar
                                        label="¿Qué aspectos crees que debe mejorar tu líder?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strAspectosMejorarJefeUno
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strAspectosMejorarJefeUno?.message ||
                                            "Selecciona el aspecto a mejorar de tu jefe"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona el aspecto a mejorar de tu jefe"
                                }}
                            />
                        </Grid>
                        {/* Aspecto a destacar */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name={`objEncuestaRetiro.strAspectosDestacarJefe`}
                                defaultValue={data.strAspectosDestacarJefe}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectAspectoDestacar
                                        label="¿Qué aspectos destacas de tu líder?"
                                        name={name}
                                        value={value}
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strAspectosDestacarJefe
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strAspectosDestacarJefe?.message ||
                                            "Selecciona el aspecto a destacar de tu jefe"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={disabled}
                                        fullWidth
                                        required
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, selecciona el aspecto a destacar de tu jefe"
                                }}
                            />
                        </Grid>
                        {/* Fuente de la oferta laboral */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="objEncuestaRetiro.strRelacionEquipoTrabajo"
                                defaultValue={data.strRelacionEquipoTrabajo}
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectRelacionEquipo
                                        label="¿Cómo describirías tu relación con tu equipo de trabajo?"
                                        name={name}
                                        value={value}
                                        error={
                                            errors?.objEncuestaRetiro
                                                ?.strRelacionEquipoTrabajo
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strRelacionEquipoTrabajo?.message ||
                                            "Selecciona como fue la relación con tu equipo de trabajo"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={isPreview ? true : disabled}
                                        required={required}
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: required ?
                                        "Por favor, selecciona como fue la relación con tu equipo de trabajo" : null
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Controller
                                defaultValue={data.btRecibisteApoyo}
                                name="objEncuestaRetiro.btRecibisteApoyo"
                                render={({ field: { name, onChange, value } }) => (
                                    <FormControl disabled={disabled} error={errors?.btRecibisteApoyo}>
                                        <FormLabel>¿Recibiste el apoyo o la guía que necesitabas para adaptarte?</FormLabel>
                                        <RadioGroup
                                            row
                                            value={value}
                                            name={name}
                                            onChange={(e) => {
                                                onChange(e)
                                                setData((prevState) => ({
                                                    ...prevState,
                                                    btRecibisteApoyo: e.target.value
                                                }))
                                            }}
                                        >
                                            <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                            <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                        </RadioGroup>
                                        <FormHelperText error={errors?.objEncuestaRetiro?.btRecibisteApoyo}>
                                            {errors?.objEncuestaRetiro?.btRecibisteApoyo?.message || "Por favor, selecciona un opción"}
                                        </FormHelperText>
                                    </FormControl>
                                )}
                                control={control}
                                rules={{
                                    validate: (value) => {
                                        if (value === null) {
                                            return "Por favor, selecciona un opción";
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        {/* Vovleria a CH */}
                        <Grid item xs={12}>
                            <Grid container >
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        defaultValue={data.btFuncionesClaras}
                                        name="objEncuestaRetiro.btFuncionesClaras"
                                        render={({ field: { name, onChange, value } }) => (
                                            <FormControl disabled={disabled} error={errors?.btFuncionesClaras}>
                                                <FormLabel>¿Consideras que tus funciones estaban claras desde el inicio?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={value}
                                                    name={name}
                                                    onChange={(e) => {
                                                        onChange(e)
                                                        setData((prevState) => ({
                                                            ...prevState,
                                                            btFuncionesClaras: e.target.value
                                                        }))
                                                        console.log(e.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                                    <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error={errors?.objEncuestaRetiro?.btFuncionesClaras}>
                                                    {errors?.objEncuestaRetiro?.btFuncionesClaras?.message || "Por favor, selecciona un opción"}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (value === null) {
                                                    return "Por favor, selecciona un opción";
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                {/* Descripción del cargo que ocupo en la empresa o emplador */}
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name={`objEncuestaRetiro.strFuncionesClarasPorque`}
                                        defaultValue={data.strFuncionesClarasPorque}
                                        render={({
                                            field: { name, value, onChange },
                                        }) => (
                                            <TextField
                                                label="¿Por qué?"
                                                name={name}
                                                value={value}
                                                disabled={disabled}
                                                multiline
                                                minRows={3}
                                                onChange={(e) => onChange(e)}
                                                fullWidth
                                                required
                                                error={
                                                    !!errors?.objEncuestaRetiro
                                                        ?.strFuncionesClarasPorque
                                                }
                                                helperText={
                                                    errors?.objEncuestaRetiro
                                                        ?.strFuncionesClarasPorque?.message ||
                                                    "Digita la observación del por qué"
                                                }
                                            />
                                        )}
                                        control={control}
                                        rules={{
                                            required: "Por favor, digita la observación del por qué",
                                            validate: (value) => {
                                                // Elimina espacios al inicio y final de cada línea
                                                let cleaned = value
                                                    .split('\n') // separa por líneas
                                                    .map(line => line.trim()) // elimina espacios en cada línea
                                                    .filter(line => line.length > 0) // elimina líneas vacías
                                                    .join(''); // une todo sin espacios
                                                if (cleaned.length <= 5) {
                                                    return "La descripción de la observación del por qué es demasiado corta";
                                                }

                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container >
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        defaultValue={data.btEspaciosFormales}
                                        name="objEncuestaRetiro.btEspaciosFormales"
                                        render={({ field: { name, onChange, value } }) => (
                                            <FormControl disabled={disabled} error={errors?.btEspaciosFormales}>
                                                <FormLabel>¿Tuviste espacios formales para conversar sobre tu desempeño y recibir retroalimentación útil?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={value}
                                                    name={name}
                                                    onChange={(e) => {
                                                        onChange(e)
                                                        setData((prevState) => ({
                                                            ...prevState,
                                                            btEspaciosFormales: e.target.value
                                                        }))
                                                        console.log(e.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                                    <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error={errors?.objEncuestaRetiro?.btEspaciosFormales}>
                                                    {errors?.objEncuestaRetiro?.btEspaciosFormales?.message || "Por favor, selecciona un opción"}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (value === null) {
                                                    return "Por favor, selecciona un opción";
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                {/* Descripción del cargo que ocupo en la empresa o emplador */}
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name={`objEncuestaRetiro.strAyudadoDesempeñarte`}
                                        defaultValue={data.strAyudadoDesempeñarte}
                                        render={({
                                            field: { name, value, onChange },
                                        }) => (
                                            <TextField
                                                label="¿Qué te hubiera ayudado a desempeñarte mejor en este tiempo?"
                                                name={name}
                                                value={value}
                                                disabled={disabled}
                                                multiline
                                                minRows={3}
                                                onChange={(e) => onChange(e)}
                                                fullWidth
                                                required
                                                error={
                                                    !!errors?.objEncuestaRetiro
                                                        ?.strAyudadoDesempeñarte
                                                }
                                                helperText={
                                                    errors?.objEncuestaRetiro
                                                        ?.strAyudadoDesempeñarte?.message ||
                                                    "Digita la observación del por qué"
                                                }
                                            />
                                        )}
                                        control={control}
                                        rules={{
                                            required: "Por favor, digita la observación del por qué",
                                            validate: (value) => {
                                                // Elimina espacios al inicio y final de cada línea
                                                let cleaned = value
                                                    .split('\n') // separa por líneas
                                                    .map(line => line.trim()) // elimina espacios en cada línea
                                                    .filter(line => line.length > 0) // elimina líneas vacías
                                                    .join(''); // une todo sin espacios
                                                if (cleaned.length <= 5) {
                                                    return "La descripción de la observación del por qué es demasiado corta";
                                                }

                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container >
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        defaultValue={data.btIdentificadoCultura}
                                        name="objEncuestaRetiro.btIdentificadoCultura"
                                        render={({ field: { name, onChange, value } }) => (
                                            <FormControl disabled={disabled} error={errors?.btIdentificadoCultura}>
                                                <FormLabel>¿Te sentiste identificado/a con la cultura de la empresa?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={value}
                                                    name={name}
                                                    onChange={(e) => {
                                                        onChange(e)
                                                        setData((prevState) => ({
                                                            ...prevState,
                                                            btIdentificadoCultura: e.target.value
                                                        }))
                                                        console.log(e.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel disabled={disabled} value={true} control={<Radio disabled={loading} />} label="Si" />
                                                    <FormControlLabel disabled={disabled} value={false} control={<Radio disabled={loading} />} label="No" />
                                                </RadioGroup>
                                                <FormHelperText error={errors?.objEncuestaRetiro?.btIdentificadoCultura}>
                                                    {errors?.objEncuestaRetiro?.btIdentificadoCultura?.message || "Por favor, selecciona un opción"}
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (value === null) {
                                                    return "Por favor, selecciona un opción";
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                {/* Descripción del cargo que ocupo en la empresa o emplador */}
                                <Grid item xs={12} md={6}>
                                    <Controller
                                        name={`objEncuestaRetiro.strIdentificadoCuturaPorque`}
                                        defaultValue={data.strIdentificadoCuturaPorque}
                                        render={({
                                            field: { name, value, onChange },
                                        }) => (
                                            <TextField
                                                label="¿Por qué?"
                                                name={name}
                                                value={value}
                                                disabled={disabled}
                                                multiline
                                                minRows={3}
                                                onChange={(e) => onChange(e)}
                                                fullWidth
                                                required
                                                error={
                                                    !!errors?.objEncuestaRetiro
                                                        ?.strIdentificadoCuturaPorque
                                                }
                                                helperText={
                                                    errors?.objEncuestaRetiro
                                                        ?.strIdentificadoCuturaPorque?.message ||
                                                    "Digita la observación del por qué"
                                                }
                                            />
                                        )}
                                        control={control}
                                        rules={{
                                            required: "Por favor, digita la observación del por qué",
                                            validate: (value) => {
                                                // Elimina espacios al inicio y final de cada línea
                                                let cleaned = value
                                                    .split('\n') // separa por líneas
                                                    .map(line => line.trim()) // elimina espacios en cada línea
                                                    .filter(line => line.length > 0) // elimina líneas vacías
                                                    .join(''); // une todo sin espacios
                                                if (cleaned.length <= 5) {
                                                    return "La descripción de la observación del por qué es demasiado corta";
                                                }

                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Fuente de la oferta laboral */}
                        <Grid item xs={12} md={6}>
                            <Controller
                                defaultValue={data.strProcesoComunicacionSalida}
                                name="objEncuestaRetiro.strProcesoComunicacionSalida"
                                render={({ field: { name, onChange, value } }) => (
                                    <SelectComunicacionSalida
                                        label="¿Cómo fue el proceso de comunicación respecto a tu salida?"
                                        name={name}
                                        value={value}
                                        error={
                                            errors?.objEncuestaRetiro
                                                ?.strProcesoComunicacionSalida
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strProcesoComunicacionSalida?.message ||
                                            "Selecciona la fuente de la comunicación"
                                        }
                                        onChange={(e) => onChange(e)}
                                        disabled={isPreview ? true : disabled}
                                        required={required}
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: required ?
                                        "Por favor, selecciona la fuente de la comunicación" : null
                                }}
                            />
                        </Grid>

                        {/* Comentario adicional */}
                        <Grid item xs={12}>
                            <Controller
                                name={`objEncuestaRetiro.strComentarioAdicional`}
                                defaultValue={data.strComentarioAdicional}
                                render={({
                                    field: { name, value, onChange },
                                }) => (
                                    <TextField
                                        label="¿Hay algo más que te gustaría compartir antes de cerrar este proceso?"
                                        name={name}
                                        value={value}
                                        disabled={disabled}
                                        multiline
                                        minRows={3}
                                        onChange={(e) => onChange(e)}
                                        fullWidth
                                        required
                                        error={
                                            !!errors?.objEncuestaRetiro
                                                ?.strComentarioAdicional
                                        }
                                        helperText={
                                            errors?.objEncuestaRetiro
                                                ?.strComentarioAdicional?.message ||
                                            "Digita un comentario adicional"
                                        }
                                    />
                                )}
                                control={control}
                                rules={{
                                    required: "Por favor, digita un comentario adicional",
                                    validate: (value) => {
                                        // Elimina espacios al inicio y final de cada línea
                                        let cleaned = value
                                            ?.split('\n') // separa por líneas
                                            ?.map(line => line.trim()) // elimina espacios en cada línea
                                            ?.filter(line => line.length > 0) // elimina líneas vacías
                                            ?.join(''); // une todo sin espacios
                                        if (cleaned?.length <= 5) {
                                            return "El comentario adicional es demasiado corto";
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>

                </Paper>
            </Box>
        </Box>
    );
};

export default PaperNoVoluntaria;
